<atn-clipboard-overlay />
<atn-check-in-wizard />
<atn-platform-toaster />
@if (featureFlags.writingHelper) {
  <atn-platform-writing-helper />
}
